import { createSlice } from '@reduxjs/toolkit'

import type { RootState } from '../store'
import { getCustomService } from '../../helpers/ReduxHelpers'
import { Page, QueryPageBySlugArgs } from '../../graphql/generated/graphql'

//
// Services
//
export const getPageBySlugService = getCustomService<'getPageBySlug', Page, QueryPageBySlugArgs>(
  'getPageBySlug'
)

//
// Initial state
//

export type DeclarationState = {
  // Service
  getPageBySlug: typeof getPageBySlugService.state
}

const initialState: DeclarationState = {
  // Service
  getPageBySlug: getPageBySlugService.state,
}

//
// Slice (Actions & Reducers)
//

const slice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    //
    // Services
    //
    ...getPageBySlugService.reducers,
  },
})

export const { reducer, actions } = slice

//
// Selectors
//

const root = (state: RootState) => state[slice.name]
const getPageBySlug = (state: RootState) => root(state).getPageBySlug

export const selectors = {
  getPageBySlug,
}
